import Component from './ReactInteractiveMap.js'
import { hydrate } from 'react-dom'

const elements = document.querySelectorAll('*[data-componentid="react_views_ReactInteractiveMap_js"]')
for (let i = 0; i < elements.length; i++) {
  const props = JSON.parse(elements[i].dataset.props)
  hydrate(<Component {...props} />, elements[i])
}

if (module.hot) {
  require('@kaliber/build/lib/hot-module-replacement-client')
  module.hot.accept('./ReactInteractiveMap.js', () => {
    for (let i = 0; i < elements.length; i++) {
      const props = JSON.parse(elements[i].dataset.props)
      hydrate(<Component {...props} />, elements[i])
    }
  })
}
